var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-only', [_c('global-modal', {
    attrs: {
      "modal-id": "ekycDetailModal",
      "modal-view": _vm.kycDetailModal.view
    },
    on: {
      "onCloseModal": function ($event) {
        _vm.kycDetailModal.view = false;
      }
    }
  }, [_c('ekyc-detail', {
    staticClass: "c--shared_ekyc-detail-modal ekyc-detail-modal",
    attrs: {
      "title": _vm.$t('scenes.ekyc.detail.navigation-title'),
      "identitiesDefault": _vm.kycDetailModal.data
    }
  })], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }